export default __webpack_public_path__ + "static/media/clairefontaine15.af0f8899.jpg";